import none from '../../img/leoLogo.png'
import pastachicken from '../../img/main/pastachicken.jpg'

export const mainFood=[
    {
      "id": "21",
      "title": "پاستا چیکن",
      "desciption": "یک نفره",
      "price": "380",
      "image": pastachicken
    },
    {
      "id": "22",
      "title": "پاستا چیکن",
      "desciption": "دو نفره",
      "price": "480",
      "image": none
    },
    {
      "id": "23",
      "title": "پاستا گرین ( سبزیجات)",
      "desciption": "",
      "price": "304",
      "image": none
    },
    {
      "id": "24",
      "title": "پاستا گرین مخصوص ( سبزیجات)",
      "desciption": "",
      "price": "390",
      "image": none
    },
    {
      "id": "25",
      "title": "پاستا بیف",
      "desciption": "",
      "price": "440",
      "image": none
    },
    {
      "id": "26",
      "title": "مزرعه سیب زمینی",
      "desciption": "سیب زمینی – قارچ – بیکن – ذرت – فلفل دلمه – زیتون – پنیر پیتزا",
      "price": "290",
      "image": none
    }
  ]